import React, { useEffect, useState } from 'react'
import { /* useNavigate, */ Navigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'

// eslint-disable-next-line react/prop-types
export default function LogOut ({ component: Component }, props) {
  // const navigate = useNavigate()
  const { i18n } = useTranslation()
  const [isAuthenticated, setIsAuthenticated] = useState(null)

  const checkSession = () => {
    const sessionValid = sessionStorage.getItem('token')

    if (sessionValid) {
      setIsAuthenticated(true)
      // console.log({ isAuthenticated })
    } else {
      setIsAuthenticated(false)
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: i18n?.language === 'en' ? 'You must log in again!' : i18n?.language === 'es' ? 'Debe iniciar sesión nuevamente!' : null,
        showConfirmButton: false,
        timer: 1500
      })
      // .then(() => navigate('/'))
    }
  }

  useEffect(() => checkSession(), [])

  if (isAuthenticated === null) return <></>

  if (!isAuthenticated) return <Navigate to="/" replace />

  return <Component {...props} />
}
